<mat-toolbar>
    <div 
        fxLayout="row" 
        fxLayoutAlign="center center" 
        fxLayoutAlign.gt-xs="space-between center" 
        fxFlex
    >
        <p style="font-size: 12px; width: 100%; text-align: center">
            Prosperidade Investimentos {{ version }}
        </p>
    </div>
</mat-toolbar>